import { render, staticRenderFns } from "./ClassHour.vue?vue&type=template&id=0bc486b2&scoped=true&"
import script from "./ClassHour.vue?vue&type=script&lang=js&"
export * from "./ClassHour.vue?vue&type=script&lang=js&"
import style0 from "./ClassHour.vue?vue&type=style&index=0&id=0bc486b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc486b2",
  null
  
)

export default component.exports